import { LoyaltyNotificationStatus } from './loyalty-notification-status';

export default class LoyaltyNotification {
    Id: string = '';
    NotificationDate: string = '';
    Title: string = '';
    Message: string = '';
    Status: LoyaltyNotificationStatus = LoyaltyNotificationStatus.New 
}